/* Star Safety - "part of this quantity ships from our supplier" note (product page), v2 19 Oct 2026.
 * The availability block (blocks/star-product-availability.liquid) prints a hidden [data-star-qty-note] element holding the Carrum Downs
 * stock of the selected variant and the wording. This script shows the note under the green stock line when the quantity asked for
 * (typed or with + / -) plus what is already in the cart is more than that stock. No figures are shown to the customer, no dialog
 * (GX: "sayi belirtmeden", not scary). The checkout then ships that line from the over-stock location (Australia Post + handling).
 * No theme internals are touched: it only reads the form fields and listens to events.
 */
(function () {
  if (window.__starQtyStock) return;
  window.__starQtyStock = true;

  function noteEl() {
    return document.querySelector('[data-star-qty-note]');
  }

  function formEl() {
    return document.querySelector('product-form-component');
  }

  function qtyInput() {
    var f = formEl();
    return f ? f.querySelector('quantity-selector-component input[name="quantity"]') : null;
  }

  function variantId() {
    var f = formEl();
    var i = f ? f.querySelector('input[name="id"]') : null;
    return i ? String(i.value) : '';
  }

  function over() {
    var n = noteEl();
    var input = qtyInput();
    if (!n || !input) return false;
    if (!n.dataset.variantId || n.dataset.variantId !== variantId()) return false;
    var stock = parseInt(n.dataset.stock, 10) || 0;
    var qty = parseInt(input.value, 10) || 0;
    var cart = parseInt(input.getAttribute('data-cart-quantity'), 10) || 0;
    return qty > 0 && stock > 0 && qty + cart > stock;
  }

  function render() {
    var n = noteEl();
    if (!n) return;
    if (!over()) {
      if (!n.hidden) n.hidden = true;
      return;
    }
    if (!n.firstChild) {
      var icon = document.createElement('span');
      icon.className = 'star-qty-note__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = 'i';
      var box = document.createElement('span');
      box.className = 'star-qty-note__text';
      var strong = document.createElement('strong');
      strong.textContent = n.dataset.lead || '';
      box.appendChild(strong);
      if (n.dataset.detail) {
        var small = document.createElement('span');
        small.textContent = n.dataset.detail;
        box.appendChild(small);
      }
      n.appendChild(icon);
      n.appendChild(box);
    }
    n.hidden = false;
  }

  var scheduled = false;
  var observer = null;
  // setTimeout, not requestAnimationFrame: rAF is held back in a tab that is not in front, which left the note one change behind
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      render();
      if (observer) observer.takeRecords();
    }, 30);
  }

  function start() {
    render();
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('quantity-selector-component input')) schedule();
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('quantity-selector-component input')) schedule();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('quantity-selector-component')) {
        setTimeout(schedule, 0);
        setTimeout(schedule, 120);
      }
    });
    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'data-cart-quantity', 'data-variant-id', 'data-stock']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
